<template>
  <div>
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-data-table
      :headers="headers"
      :items="errands"
      :items-per-page="10"
      :loading="loading"
      sort-by="name"
      class="mt-5"
      :sort-desc="true"
      :search="searchTerm"
      item-key=".key"
      :footer-props="{
        itemsPerPageOptions: [10, 50, 100],
      }"
    >
      <template v-slot:[`item.state`]="{ item }">
        <v-chip class="white--text" :color="getColor(item.state)">{{
          item.state | statusFilter
        }}</v-chip>
      </template>

      <template v-slot:[`item.total`]="{ item }">
        {{ item.orderTotal | currency }}
      </template>

      <template v-slot:[`item.shipping`]="{ item }">
        {{ item.deliveryCost.toFixed(2) | currency }}
      </template>

      <template v-slot:[`item.totalProducts`]="{ item }">
        {{ item.productsTotal.toFixed(2) | currency }}
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | tsToDate }}
      </template>

      <template v-slot:[`item.shortId`]="{ item }">
        <v-tooltip v-if="item.shortId" right>
          <template v-slot:activator="{ on }">
            <v-chip
              :color="
                $vuetify.theme.dark
                  ? 'rgba(0, 0, 0, 0.4)'
                  : 'rgba(0, 0, 0, 0.1)'
              "
              style="display: inline-block"
              v-on="on"
              dark
              :text-color="$vuetify.theme.dark ? 'white' : 'black'"
              @click="copyToClipboard(item.shortId)"
            >
              {{ item.shortId }}
            </v-chip>
          </template>
          <i class="far fa-copy mr-2"></i>
          <span>Click para copiar</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.options`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="gray"
              :loading="loading"
              :disabled="item.state != 'pending'"
              v-on="on"
              :dark="$vuetify.theme.dark"
              x-small
              @click="copyToClipboard(item.OPLResult.redirectUri)"
              :elevation="0"
            >
              <v-icon color="primary" dark>fas fa-link</v-icon>
            </v-btn>
          </template>
          <span>Copiar enlace</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="gray"
              :loading="loading"
              v-on="on"
              :dark="$vuetify.theme.dark"
              x-small
              @click="showInfo(item)"
              :elevation="0"
            >
              <v-icon color="blue" dark>fas fa-info</v-icon>
            </v-btn>
          </template>
          <span>Ver detalles</span>
        </v-tooltip>

        <!-- <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              color="gray"
              :loading="loading"
              v-on="on"
              :dark="$vuetify.theme.dark"
              x-small
              :disabled="item.state != 'pending'"
              @click="cancelLink(item)"
              :elevation="0"
            >
              <v-icon color="red" dark>fas fa-ban</v-icon>
            </v-btn>
          </template>
          <span>Cancelar</span>
        </v-tooltip> -->
      </template>
    </v-data-table>

    <v-dialog
      v-model="informationDialog"
      v-if="informationDialog && selectedErrand"
      max-width="700"
      persistent
    >
      <information
        @cancel="informationDialog = false"
        :opl="selectedErrand"
      ></information>
    </v-dialog>

    <v-dialog
      v-model="cancelDialog"
      v-if="cancelDialog && selectedErrand"
      max-width="700"
      persistent
    >
      <cancel
        @cancel="cancelDialog = false"
        @confirm="cancelConfirmed"
        :opl="selectedErrand"
      ></cancel>
    </v-dialog>
    <!-- <div class="errandsHeader">
      <span>Estado</span>
      <span>Código</span>
      <span>Costo de Envío</span>
      <span>Producto</span>
      <span>Total</span>
      <span class="date">Fecha Creación</span>
      <span></span>
    </div>
    <div v-if="errands && errands.length" class="errandsContainer">
      <ul>
        <li
          v-for="errand in errands"
          :key="errand['.key']"
          class="errand"
          :class="errand.state"
        >
          <div class="errandBody">
            <div class="rowItem">
              <div
                :style="`background-color: ${getColor(
                  errand.state
                )}!important; justify-content:center!important`"
                class="status"
              >
                {{ errand.state | statusFilter }}
              </div>
            </div>

            <div class="rowItem">{{ errand.shortId }}</div>

            <div class="rowItem">
              {{ errand.shipping ? errand.shipping.toFixed(2) : 0 }} HNL
            </div>

            <div class="rowItem">{{ errand.totalProducts }} HNL</div>

            <div class="rowItem">
              {{
                errand.totalProducts + (errand.shipping ? errand.shipping : 0)
              }}
              HNL
            </div>

            <div class="rowItem date">
              <div style="width: 100%">{{ errand.createdAt | tsToDate }}</div>
              <span>{{ errand.createdAt | tsToRelative }}</span>
            </div>

            <div class="rowItem options">
              <button @click="showLink(errand)" class="link">
                <i class="fas fa-link"></i>
              </button>

              <button @click="showInfo(errand)" class="info">
                <i class="fas fa-info"></i>
              </button>

              <button
                :style="
                  errand.state != 'pending' ? `background-color: #d1d1d1` : ''
                "
                @click="cancelLink(errand)"
                :disabled="errand.state != 'pending'"
                class="cancel"
              >
                <i class="fas fa-ban"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div> -->

    <!-- <div v-else class="no-result">
      <p>No se encontraron resultados.</p>
    </div> -->

    <!-- <transition name="fade">
      <div id="myModal" class="modal" v-if="link">
        <div
          style="margin-top: 10%; width: 600px; padding: 20px' ; padding-bottom : 0"
          class="modal-content"
        >
          <div class="payment">
            <h2 style="margin-bottom: 15px">Copiar enlace</h2>
            <i @click="link = ''" class="fas fa-times close-link"></i>

            <div class="grid">
              <input id="link" type="text" class="link" v-model="link" />
              <input
                @click="copyToClipboard(link)"
                class="copy"
                type="button"
                value="Copiar"
              />
            </div>
          </div>
        </div>
      </div>
    </transition> -->

    <!-- s -->

    <!-- <transition name="fade">
      <cancel
        @cancel="cancelDialog = false"
        v-if="cancelDialog"
        :errand="selectedErrand"
        @confirm="cancelConfirmed"
        :loading="canceling"
      />
    </transition> -->
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import information from "@/components/pay-link-details";
import cancel from "@/components/cancel-opl";

import { mapState } from "vuex";

export default {
  name: "Tracking",
  props: ["errands"],
  components: {
    DateRangePicker,
    information,
    cancel,
  },
  data() {
    return {
      // toRange: 1,
      // fromRange: 9,
      // qtyRange: 9,
      // totalRange: 100,
      // currentPage: 1,
      // totalPages: 10,
      // business: null,
      detailsDialog: true,
      selectedErrand: null,
      cancelDialog: false,
      snackbarText: "",
      snackbar: false,
      // link: "",
      dateRange: {
        startDate: new Date(),
        endDate: new Date(),
      },
      selectedStatus: "",
      tookanPoints: [],
      informationDialog: false,
      canceling: false,
      loading: false,
      headers: [
        { text: "Estado", value: "state" },
        { text: "ID", value: "shortId" },
        { text: "Costo de Envío", value: "shipping" },
        { text: "Producto", value: "totalProducts" },
        {
          text: "Total",
          value: "total",
        },
        {
          text: "Fecha Creación",
          value: "createdAt",
        },
        {
          text: "",
          value: "options",
          align: "end",
        },
      ],
    };
  },

  // <span>Estado</span>
  //     <span>Código</span>
  //     <span>Costo de Envío</span>
  //     <span>Producto</span>
  //     <span>Total</span>
  //     <span class="date">Fecha Creación</span>
  //     <span></span>

  computed: {
    ...mapState(["searchTerm"]),
  },

  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      var splitStr = value.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return " " + splitStr.join(" ");
    },
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },

    date(data) {
      return data ? moment.utc(data).format("DD/MM/YYYY") : "";
    },

    statusFilter: function (status) {
      switch (status) {
        case "paid":
          return "Pagado";
          break;

        case "pending":
          return "Pendiente";
          break;

        case "canceled":
          return "Cancelado";
          break;

        case "expired":
          return "Vencido";
          break;

        default:
          return status;
          break;
      }
    },

    tsToDate: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate())
        .tz("America/Tegucigalpa")
        .format("DD/MM/YYYY, hh:mm A");
    },
    tsToRelative: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate()).tz("America/Tegucigalpa").fromNow();
    },
  },

  methods: {
    showInfo(errand) {
      this.selectedErrand = errand;
      this.informationDialog = true;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.snackbarText = "Copiado al portapapeles";
          this.snackbar = true;
        },
        (err) => {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
    async filter() {
      this.$store.commit("setLoading", "Cargando...");

      let query = db
        .collection("paymentLinks")
        .where("businessId", "==", this.$store.state.user.businessID);

      if (this.selectedStatus) {
        query = query.where("state", "==", this.selectedStatus);
      }

      if (this.dateRange.startDate && this.dateRange.endDate) {
        query = query
          .where(
            "createdAt",
            ">",
            moment.utc(this.dateRange.startDate).startOf("day").toDate()
          )
          .where(
            "createdAt",
            "<",
            moment.utc(this.dateRange.endDate).endOf("day").toDate()
          );
      }

      query = query.orderBy("createdAt", "desc");

      // console.log(query);

      await this.$binding("errands", query);
      setTimeout(() => {
        this.$store.commit("setLoading", "");
        // this.$store.commit("setNavBar", false);
      }, 500);
    },

    getColor(status) {
      switch (status) {
        case "pending":
          return "#bfa002";
          break;

        case "paid":
          return "green";
          break;

        case "canceled":
          return "red";
          break;

        case "expired":
          return "#999910";
          break;

        default:
          return "gray";
          break;
      }
    },

    cancelConfirmed() {
      this.canceling = true;
      db.collection("paymentLinks")
        .doc(this.selectedErrand[".key"])
        .update({
          state: "canceled",
        })
        .then((response) => {
          // this.$store.commit("setNotification", "Enlace de pago cancelado.");
          // this.$store.commit("setNotification", true);
          this.snackbarText = "Enlace de pago cancelado.";
          this.snackbar = true;
          this.canceling = false;
          this.cancelDialog = false;
        })
        .catch((error) => {
          // this.$store.commit(
          //   "setNotification",
          //   "Ocurrió un error inesperado, inténtelo nuevamente."
          // );
          // this.$store.commit("setNotification", true);
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          this.canceling = false;
        });
    },

    // showLink(errand) {
    //   this.selectedErrand = errand;
    //   this.detailsDialog = true;
    //   this.link = `https://ocho-pay.web.app/payment/checkout/${errand.shortId}`;
    // },

    cancelLink(errand) {
      this.selectedErrand = errand;
      this.cancelDialog = true;
    },

    // showMap(index) {
    //   if (
    //     this.tookanPoints[index] &&
    //     this.tookanPoints[index].result_tracking_link
    //   ) {
    //     let url = this.tookanPoints[index].result_tracking_link;
    //     window.open(url);
    //   }
    // },
  },
  // watch: {},
};
</script>

<style lang="scss">
// .options {
//   justify-content: flex-end !important;

//   button {
//     width: 30px;
//     height: 30px;
//     margin-right: 10px;
//     color: white;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     border-radius: 50%;
//     padding: 15px;
//     cursor: pointer;
//     font-weight: bold;
//     background-color: rgb(151, 151, 151);
//     border: 0;
//   }

//   .info {
//     background-color: #1867c0;
//   }

//   .link {
//     background-color: gray;
//   }
//   .cancel {
//     background-color: rgb(190, 20, 20);
//   }
// }

// .errands-container {
//   display: flex;
//   color: #000000ad;
//   justify-content: flex-start;
//   align-items: center;
// }

.number {
  background-color: #FF1744;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: white;
  padding: 3px;
  margin-right: 10px;
}

.point {
  padding: 15px;
}

.point-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  max-width: 100%;
  overflow: hidden;
}

.detail {
  text-align: left;
  padding: 5px;
  margin-left: 10px;
  font-size: 16px;

  max-width: 100%;
  overflow: hidden;
}

.view {
  font-size: 13px;
  text-align: start;
  margin-left: 15px;
  margin-top: 10px;
}

.view a {
  cursor: pointer;
  color: #002679;
}

.cost {
  background-color: #ffceb57a;
  height: 100%;
}

.close {
  width: 20px;
}

.status {
  border-radius: 40px;
  color: white;
  padding: 10px;
  width: 90%;
  max-width: 90%;
  text-align: center;
}

.option {
  padding: 10px;
}

// .headers {
//   display: grid;
//   grid-template-columns: 25% 28% 28% 16%;
//   align-items: center;
//   margin-bottom: 20px;
//   padding: 15px;
//   padding-top: 0;
// }

select:focus,
select:focus {
  outline: none;
}

.no-result {
  text-align: center;
  margin-top: 7%;
  color: gray;
  font-size: 25px;
}

.close-link {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
}

.grid {
  display: grid;
  grid-template-columns: 80% 20%;
  align-items: center;
  margin-bottom: 15px;
}

#link {
  margin: 10px;
  height: 40px;
  padding: 5px;
  border-radius: 20px;
  border: none;
  background-color: #8080801c;
  font-weight: bold;
}

.copy {
  border-radius: 20px;
  border: 0;
  background-color: #FF1744;
  height: 40px;
  padding: 5px;
  color: white;
  font-weight: bold;
  margin: 10px;
  cursor: pointer;
}

.fa-link .fa-info {
  cursor: pointer;
  color: rgb(255, 255, 255);
}

// .fa-times {
//   position: absolute;
//   right: 2%;
//   top: 5%;
//   color: gray;
//   cursor: pointer;
//   padding: 10px;
//   font-size: 20px;
//   width: 30px;
//   height: 30px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
// .fa-times:hover {
//   border-radius: 50%;
//   background-color: rgba(126, 126, 126, 0.144);
//   color: black;
//   font-weight: bold;
// }
</style>

